
import Map from "@/utils/Map";

export default class Map_MediaElement {
  viewer;
  datasource;
  max_distance_show;
  cartographics;
  lastEventMouseMove;
  timerMouseTime;
  timerMouse;
  isActive;
  listPrimitiveMission;
  frustum;

  constructor(viewer) {
    this.viewer = viewer;
    this.datasource;
    this.max_distance_show = 5000;
    this.cartographics = [];
    this.lastEventMouseMove = undefined;
    this.timerMouse = undefined;
    this.timerMouseTime = 100;
    this.isActive = false;
    this.listPrimitiveMission = [];
    this.frustum = undefined;
    this.init();
  }

  init() {
    this.datasource = new Cesium.CustomDataSource("MapMediaElements");
    this.viewer.dataSources.add(this.datasource);
    this.frustum = {near :5, far: 250, fov :80 , heading :0, pitch:-45,zoom:4, startheading:0, startPitch:0, startMouseX :0,startMouseY :0, prim : undefined, primout : undefined, isAction : false};

    this.initEvents();

  }

  clear() {
    this.datasource.entities.removeAll();
    this.listPrimitiveMission.forEach((primitive) => {
      this.datasource._primitives.remove(primitive);
    });
    this.cartographics= [];
    this.listPrimitiveMission = [];
  }

  activate(isActive) {
    this.pickActive = isActive;
  }

  initEvents() {

    this.timerMouse = setInterval(() => {
      if(this.lastEventMouseMove !== undefined){
        this.mouseMove(this.lastEventMouseMove);
        this.lastEventMouseMove = undefined;
      }
    }, this.timerMouseTime);

    let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    handler.setInputAction((event) => {

      if (this.pickActive) {
        this.lastEventMouseMove = event;
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handler.setInputAction((event) => {
      if (this.pickActive) {
        const pickedObject = this.pickEntiy(event.position);
        if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id.frfid) {
          $root.global.media.frf_id = pickedObject.id.frfid;
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  }

  mouseMove(event) {

    const pickedObject = this.pickEntiy(event.endPosition);
    if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id.frfid) {
      this.viewer.canvas.style.cursor = "copy";
    }
    else{
      this.viewer.canvas.style.cursor = "";
    }
  }

  pickEntiy(position) {
    const pickedObject = this.viewer.scene.pick(position);
    return pickedObject;
  }

  addMedia(files) {
    this.clear();

    if(files !== undefined && files.length >0){
      files.forEach((file) => {
        const cartographic = this.getMediaPosition(file);
        if(Cesium.defined(cartographic)) {
          this.cartographics.push(cartographic);
          const cartesian = Cesium.Cartesian3.fromDegrees(file.lng, file.lat,file.altabs);
          const entity = this.getEntityPoint(cartesian);
          entity.frfid = file.frf_id;
          this.datasource.entities.add(entity);
        }
      });
    }
   // const rectangle = this.getCentroid();
  //  Map.flyToRectangle(rectangle);
  }

  getMediaPosition(file) {
    let cartographic = undefined;
    if(file.lng && file.lat && file.lng !== 0 && file.lat !==0){
      let height =0;
      if(file.altabs !== undefined) {
        height = file.altabs;
      }
      cartographic = new Cesium.Cartographic( file.lng, file.lat,height);
    }
    return cartographic;
  }

  selectMedia(file) {
    const entity = this.getEntityById(file.frf_id);
    if(Cesium.defined(entity)) {
      this.showFustrum(file);
      this.flyToEntity(entity);
    }
  }

  showFustrum(file) {
    const cartographic = this.getMediaPosition(file);
    if(Cesium.defined(cartographic)) {
      const heading = parseFloat(file?.meta?.XMP?.GimbalYawDegree);
      const pitch = parseFloat(file?.meta?.XMP?.GimbalPitchDegree);
      if(!isNaN(heading) && !isNaN(pitch)) {
        this.frustum.heading = heading;
        this.frustum.pitch = pitch;
        this.addFrustum();
        this.updateFrustum(cartographic);
      }
      else{
        this.hideFrustrum();
      }
    }
    else{
      this.hideFrustrum();
    }
  }

  flyToEntity(entity) {

    if(Cesium.defined(entity)) {
      this.viewer.flyTo(entity, {
        duration: 2.0,
        offset: new Cesium.HeadingPitchRange(
          Cesium.Math.toRadians(0),
          Cesium.Math.toRadians(-55),
          120
        ),
      });
    }
  }

  getEntityById(id) {
    let resu = undefined;
    this.datasource.entities.values.forEach((entity) => {
      if(entity.frfid && entity.frfid === id) {
        resu = entity;
      }
    });
    return resu;
  }

  getEntityPoint(cartesian) {
    let entity = {
      position: cartesian,
      billboard: {
        image:
          `data:image/svg+xml;base64,` + btoa($root.svg_map_path.picture),
        color: Cesium.Color.WHITE,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
        scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e7, 0.2),
        pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
          1.0e3,
          0.8,
          1.5e6,
          0.0
        ),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.NONE,
        show: true
      },
    };
    return entity;
  }

  getCentroid() {

    if(this.cartographics.length >0) {
      const dim = this.getBboxDim();
      let coords = [];

      if(dim.dimx > dim.dimy) {
        dim.dimy = Math.max(dim.dimx,0.002);
      }
      else{
        dim.dimx = Math.max(dim.dimy,0.002);
      }
      const cartographic1 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx - dim.dimx), Cesium.Math.toRadians(dim.centery - dim.dimy * 2.0), dim.centerz);
      const cartographic2 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx + dim.dimx), Cesium.Math.toRadians(dim.centery - dim.dimy * 2.0), dim.centerz);
      const cartographic3 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx - dim.dimx), Cesium.Math.toRadians(dim.centery), dim.centerz);
      const cartographic4 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx + dim.dimx), Cesium.Math.toRadians(dim.centery), dim.centerz);

      coords.push(cartographic1);
      coords.push(cartographic2);
      coords.push(cartographic3);
      coords.push(cartographic4);

      const rectangle = Cesium.Rectangle.fromCartographicArray(coords);
      return rectangle;
    }
  }

  getBboxDim() {
    let bbox = {xmin :180, xmax : -180, ymin:  90, ymax : -90, zmin : 1000, zmax :0};
    this.cartographics.forEach((cartographic) => {
      if(cartographic.longitude < bbox.xmin) {
        bbox.xmin = cartographic.longitude;
      }
      if(cartographic.longitude > bbox.xmax) {
        bbox.xmax = cartographic.longitude;
      }
      if(cartographic.latitude < bbox.ymin) {
        bbox.ymin = cartographic.latitude;
      }
      if(cartographic.latitude > bbox.ymax) {
        bbox.ymax = cartographic.latitude;
      }
      if(cartographic.height < bbox.zmin) {
        bbox.zmin = cartographic.height;
      }
      if(cartographic.height > bbox.zmax) {
        bbox.zmax = cartographic.height;
      }
    });
    const dimx = bbox.xmax - bbox.xmin;
    const dimy = bbox.ymax - bbox.ymin;
    const centerx = (bbox.xmax + bbox.xmin) /2;
    const centery = (bbox.ymax + bbox.ymin) /2;
    const centerz = (bbox.zmax + bbox.zmin) /2
    return {centerx: centerx, centery: centery, centerz: centerz, dimx:dimx,dimy:dimy};
  }

  addFrustum() {

    if(this.frustum.prim !== undefined) {
      this.datasource._primitives.remove(this.frustum.prim);
      this.frustum.prim = undefined;
    }
    if(this.frustum.primout !== undefined) {
      this.datasource._primitives.remove(this.frustum.primout);
      this.frustum.primout = undefined;
    }

    let frustum = new Cesium.PerspectiveFrustum();
		frustum.fov = Cesium.Math.toRadians(this.frustum.fov / this.frustum.zoom);
		frustum.aspectRatio =  this.viewer.canvas.height/ this.viewer.canvas.width;
		frustum.near = this.frustum.near;
		frustum.far = this.frustum.far;

    let colorprim = new Cesium.Color(1.0, 1.0, 1.0, 0.15);
    let colorprimout = new Cesium.Color(0.0, 1.0, 0.0, 0.2);

    let prim = new Cesium.Primitive({
      geometryInstances: new Cesium.GeometryInstance({
        geometry: new Cesium.FrustumGeometry({
          origin: new Cesium.Cartesian3(0,0,0),
          orientation: Cesium.Quaternion.fromHeadingPitchRoll(new Cesium.HeadingPitchRoll(0,0,0), new Cesium.Quaternion()),
          frustum: frustum,
          _drawNearPlane : true,
        }),
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(
            colorprim
          ),
        },
        id: 'frustum',
        pickPrimitive: this,
      }),
      appearance: new Cesium.PerInstanceColorAppearance({
        translucent: true,
        flat: true,
      }),
      asynchronous: false,
    });


    this.frustum.prim = this.datasource._primitives.add(prim);
    this.listPrimitiveMission.push(this.frustum.prim);
    let primout = new Cesium.Primitive({
      geometryInstances: new Cesium.GeometryInstance({
        geometry: new Cesium.FrustumOutlineGeometry({
          origin: new Cesium.Cartesian3(0,0,0),
          orientation: Cesium.Quaternion.fromHeadingPitchRoll(new Cesium.HeadingPitchRoll(0,0,0), new Cesium.Quaternion()),
          frustum: frustum,
          _drawNearPlane: true,
        }),
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(
            colorprimout
          ),
        },
        id: 'frustumline',
        pickPrimitive: this,
      }),
      appearance: new Cesium.PerInstanceColorAppearance({
        translucent: false,
        flat: true,
      }),
      asynchronous: false,
    });

    this.frustum.primout = this.datasource._primitives.add(primout);
    this.listPrimitiveMission.push(this.frustum.primout);
  }

  hideFrustrum() {
    this.frustum.prim.modelMatrix = Cesium.Matrix4.IDENTITY;
    this.frustum.primout.modelMatrix = Cesium.Matrix4.IDENTITY;
  }

  updateFrustum(cartographic) {

    const cartesian = this.cartesian3FromCartographicDegrees(cartographic);
		const hpr = new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(this.frustum.heading), Cesium.Math.toRadians(this.frustum.pitch - 90), 0);

    const fixedFrameTransform = Cesium.Transforms.localFrameToFixedFrameGenerator('north', 'west');
		const matrix = Cesium.Transforms.headingPitchRollToFixedFrame(cartesian, hpr , Cesium.Ellipsoid.WGS84, fixedFrameTransform);
		if(this.frustum.prim !== undefined && this.frustum.primout !== undefined) {
      this.frustum.prim.modelMatrix = matrix;
      this.frustum.primout.modelMatrix = matrix;
    }
  }

  cartesian3FromCartographicDegrees(cartographic) {
    const cartesian = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height
    );
    return cartesian;
  }

}
